import { MAP_LAYER_IDS, SIDEBAR_VIEWS } from "../../../../../lib/constants";
import AlertCircle from "../../../../../assets/svg/Feather/AlertCircle";


export default (dispatch) => ({
  handleResultSelect: (event, data) => {
    dispatch({
      type: 'features/setSelectedFeatureLoading',
      payload: true
    });
    dispatch({
      type: 'features/setSelectedFeature',
      payload: data.feature,
    });
    dispatch({
      type: 'app/setSideBarScrollPosition',
      payload: { features: data.feature.uuid },
    })
    dispatch({
      type: 'app/gotoSidebarWithHistory',
      payload: SIDEBAR_VIEWS.FeatureDetail
    });
    dispatch({
      type: 'features/getFeature',
      payload: data.feature.uuid,
      callback: (feature, error) => {
        if (feature) {
          dispatch({
            type: 'features/setSelectedFeature',
            payload: feature,
          });
          dispatch({
            type: 'features/setPreviousFeatureState',
            payload: feature,
          });
          dispatch({
            type: 'map/goToFeature',
            payload: {
              featureId: feature.uuid,
              layerId: MAP_LAYER_IDS.content,
            },
          });
        } else {
          dispatch({
            type: 'app/navSidebarBack'
          });
          dispatch({
            type: 'features/setSelectedFeature',
            payload: null
          });
          let toastPayloadText = 'Oops, there was an issue retrieving the feature'
          if (error.status == 404) {
            toastPayloadText = 'Sorry, but it looks like that feature does not exist'
            dispatch({
              type: 'features/removeFeatureFromUserDataEffect',
              payload: data.feature.uuid
            })
          }
          dispatch({
            type: 'toast/show',
            payload: {
              dismissable: true,
              icon: AlertCircle,
              iconColor: '#FF3B30',
              text: toastPayloadText,
            }
          });
        }
        dispatch({
          type: 'features/setSelectedFeatureLoading',
          payload: false
        });
      },
    });
  }
})